import { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../../services/firebase';
import { jtncDailyPnlFromBacklogs } from '../../../utils/jtncDailyFromBacklogs';

/**
 * Daily JTNC P&L for the Portfolio Overview chart, built from the client's own
 * tbl_user_order_backlogs rows (owner-readable). tbl_user_daily_pnl is not used here
 * because it already sums trades the client managed themselves.
 * Returns null while loading, then [{ date, pnl, bySymbol }].
 */
export default function useJtncDailyPnl(userId) {
  const [daily, setDaily] = useState(null);

  useEffect(() => {
    if (!userId || !db) {
      setDaily([]);
      return undefined;
    }
    let cancelled = false;
    setDaily(null);
    getDocs(query(collection(db, 'tbl_user_order_backlogs'), where('userId', '==', userId)))
      .then((snap) => {
        if (!cancelled) setDaily(jtncDailyPnlFromBacklogs(snap.docs.map((d) => d.data())));
      })
      .catch((err) => {
        console.error('Portfolio Overview: JTNC trades load failed:', err);
        if (!cancelled) setDaily([]);
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return daily;
}
